import {createStrokeSVG} from './TEMPLATE'

// lucide: corner-down-right
export const ArrowCornerDownRight_Stroke2_Corner2_Rounded = createStrokeSVG({
  paths: ['m15 10 5 5-5 5', 'M4 4v7a4 4 0 0 0 4 4h12'],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})

// lucide: corner-down-right
export const ArrowCornerDownRight_Stroke2_Corner3_Rounded = createStrokeSVG({
  paths: ['m15 10 5 5-5 5', 'M4 4v7a4 4 0 0 0 4 4h12'],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
